//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { FIND_ENCUESTA_BY_ID } from "@/graphql/queries/encuestas.js";
import { FILL_ENCUESTA } from "@/graphql/mutations/encuestas.js";
import BasicEncuesta from "@/components/BasicEncuesta";
import SliderEncuesta from "@/components/SliderEncuesta";
import HourEncuesta from "@/components/HourEncuesta";

export default {
  name: "Rapid3Encuesta",
  components: {
    BasicEncuesta,
    SliderEncuesta,
    HourEncuesta
  },
  apollo: {
    encuesta: {
      query: FIND_ENCUESTA_BY_ID,
      variables: {
        id: null
      },
      update(data) {
        if (data.findEncuestaBy) {
          if (
            data.findEncuestaBy.tipo_encuesta &&
            data.findEncuestaBy.tipo_encuesta.help
          ) {
            EventBus.$emit("dynamic-help", {
              help: data.findEncuestaBy.tipo_encuesta.help.html
            });
          }
          this.$q.loading.hide();
          this.loaded = true;
          return data.findEncuestaBy;
        }
        this.$q.loading.hide();
        this.loaded = true;
        return {};
      },
      skip() {
        return true;
      }
    }
  },
  mounted() {
    this.$q.loading.show();
    EventBus.$emit("page-loaded", { page: "Rapid3Encuesta" });
    this.internalId = +this.$route.params.id;
    this.$apollo.queries.encuesta.setVariables({
      id: this.internalId
    });
    this.$apollo.queries.encuesta.skip = false;
    this.$apollo.queries.encuesta.refetch();
    if (this.$route.query) {
      this.readOnly = this.$route.query.readOnly;
    } else {
      this.readOnly = false;
    }
  },
  data() {
    return {
      encuesta: {
        tipo_encuesta: {}
      },
      resultados: [],
      internalId: null,
      resultadoNumerico: 0,
      resultadoFinal: null,
      color: null,
      readOnly: false,
      observaciones: "",
      generalState: null,
      showResultado: false,
      loaded: false
    };
  },
  watch: {
    encuesta: {
      deep: true,

      // We have to move our method to a handler field
      handler(newParam) {
        if (this.readOnly) {
          this.resultados = newParam.respuestas;
          this.resultadoNumerico = +newParam.resultado_numerico;
          this.resultadoFinal = newParam.resultado;
          this.color = newParam.color;
          this.generalState = !!newParam.observaciones;
          this.observaciones = newParam.observaciones;
        }
        console.log(newParam);
      }
    }
  },
  methods: {
    showResultadoAction() {
      this.showResultado = true;
    },
    async enviarResultados() {
      let expectedTotal = 0;
      const respuestas = this.resultados.filter(e => e !== null).length;
      // const respuestas = this.resultados.length;
      for (let j in this.encuesta.tipo_encuesta.preguntas) {
        expectedTotal += this.encuesta.tipo_encuesta.preguntas[j].preguntas
          .length;
      }
      debugger;
      if (this.generalState === null) {
        this.$q.notify({
          position: "top-right",
          message: "Por favor, indique su estado actual",
          color: "positive"
        });
      }
      if (this.generalState && !this.observaciones) {
        this.$q.notify({
          position: "top-right",
          message: "Por favor, indique en el campo indicado su estado actual",
          color: "positive"
        });
      }
      if (
        respuestas === expectedTotal &&
        ((this.generalState && this.observaciones) || !this.generalState)
      ) {
        try {
          let resultado = await this.$apollo.mutate({
            mutation: FILL_ENCUESTA,
            variables: {
              id_encuesta: this.internalId,
              respuestas: this.resultados,
              observaciones: this.observaciones
            }
          });
          this.resultadoNumerico = +resultado.data.fillEncuesta
            .resultado_numerico;
          this.resultadoFinal = resultado.data.fillEncuesta.resultado;
          this.color = resultado.data.fillEncuesta.color;
          this.showResultadoAction();

          this.$q.notify({
            position: "top-right",
            message: "La encuesta se ha completado correctamente",
            color: "positive"
          });
        } catch (e) {
          this.$q.notify({
            position: "top-right",
            message: "Ha habido un error al completar la encuesta.",
            color: "negative"
          });
        }
      } else {
        this.$q.notify({
          position: "top-right",
          message: "Por favor, rellene todas las opciones",
          color: "positive"
        });
      }
    }
  }
};
